module.exports = __webpack_public_path__ + "img/菊花.44c2235b.jpg";